// extracted by mini-css-extract-plugin
export default {"link":"Submit-module_link_bd4a22","disabled":"Submit-module_disabled_f98d93","label":"Submit-module_label_c00c87","fullWidth":"Submit-module_fullWidth_cda0bc"};